let emailRegex = null;

function validateEmail(email) {
  if (emailRegex === null) {
    emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  }
  return emailRegex.test(String(email).toLowerCase());
}

function validatePassword(pass) {
  return pass.length >= 8;
}

export { validateEmail, validatePassword };
